import React from 'react';
import MUIDataTable from "mui-datatables";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

//Constants
import { table_style } from "../../constants/MaterialTable";
//Assets
import "../../assets/css/tabelaListagem.css";

export default function TabelaListagemExpandable({ options, title = "", headers, items, expandableRows = null, expandableHeaders, expandableColSpan = 1, actionsExpandable = [] }) {

    return (
        <div className={` mb-4 w-100 `}>
            <MUIDataTable style={{ minHeight: "auto" }}
                title={title}
                columns={[...headers.map(value => {
                    return {
                        label: value.value,
                        name: value.objectValue,
                        setCellHeaderProps: () => ({
                            align: value.align ?
                                value.align :
                                "center",
                        }),
                        setCellProps: () => ({
                            align: value.align ?
                                value.align :
                                "center",
                        }),
                        options: value.options ? {
                            ...value.options,
                        } : {
                        }
                    }
                })
                ]}
                isLoading={false}
                options={{
                    ...options,
                    filter: false,
                    selectableRows: "none",
                    download: false,
                    ...table_style,
                    pageSize: 10,
                    expandableRows: true,
                    renderExpandableRow: (rowData, rowMeta) => {
                        return (
                            <React.Fragment>

                                <tr>
                                    <td colspan={expandableColSpan} className={"subTable"}>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table">
                                                <TableHead>
                                                    <TableRow>
                                                        {actionsExpandable.length > 0
                                                            ?
                                                            <TableCell className='fw-bold text-secondary' align={"center"}>Ações</TableCell>
                                                            :
                                                            <></>
                                                        }
                                                        {expandableHeaders.map(value => {
                                                            return (
                                                                <TableCell className='fw-bold text-secondary' align={value.align ? value.align : "center"}>{value.value}</TableCell>
                                                            );

                                                        })}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>

                                                    {expandableRows && items[rowMeta.dataIndex][expandableRows] ? items[rowMeta.dataIndex][expandableRows].map((row, index) => {
                                                        //Definindo os ids para acesso do item selecionado
                                                        row.tableData = { mainId: rowMeta.dataIndex, secondId: index };
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell align={"center"}>
                                                                    {

                                                                        actionsExpandable.length > 0
                                                                            ? actionsExpandable.map((value, index) => {
                                                                                if (typeof value === 'function') {

                                                                                    const functionValue = value(row);
                                                                                    if (functionValue != null) {
                                                                                        return <button key={index} className={`tableOption ${functionValue.color}`} onClick={(e) => {
                                                                                            functionValue.onClick(e, row)
                                                                                        }}><FontAwesomeIcon icon={functionValue.icon} /></button>
                                                                                    }
                                                                                } else {
                                                                                    if (value.tooltip) {
                                                                                        return <button key={index} className={`me-2 tableOption ${value.color}`} onClick={(e) => {
                                                                                            value.onClick(e, row);
                                                                                        }}><FontAwesomeIcon icon={value.icon} /></button>
                                                                                    }
                                                                                }
                                                                            })
                                                                            : <></>
                                                                    }

                                                                </TableCell>
                                                                {
                                                                    expandableHeaders.map(value => {
                                                                        return (
                                                                            <TableCell align={value.align ? value.align : "center"}>{row[value.objectValue]}</TableCell>
                                                                        );
                                                                    })
                                                                }

                                                            </TableRow>
                                                        );
                                                    }) : <TableCell colSpan={expandableHeaders.length + 1}>Nenhum registro encontrado</TableCell>}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </td>
                                </tr>
                            </React.Fragment>
                        );
                    },
                }}
                data={items}
            />
        </div >
    )
}